import React from 'react';
import { useIntl } from 'react-intl';
import SceneAction from '../SceneAction';
import { isMeasurementsVisible, hideMeasurements, showMeasurements } from 'ducks/layout';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useAppDispatch } from 'ducks/hooks';
import { setHelpLinesLabelsVisible } from 'ducks/helpLines';
import Icon from '@ingka/ssr-icon/paths/ruler';

const Button = styled(SceneAction)``;

const MeasureAction = (props: React.PropsWithoutRef<JSX.IntrinsicElements['button']>) => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const active = useSelector(isMeasurementsVisible);

  return (
    <Button
      {...props}
      dataTestId="toggle-measurement"
      label={
        active
          ? formatMessage({ id: 'storageone.sceneMenuHideMeasure' })
          : formatMessage({ id: 'storageone.sceneMenuShowMeasure' })
      }
      onClick={() => {
        if (active) {
          dispatch(hideMeasurements());
          dispatch(setHelpLinesLabelsVisible(false));
        } else {
          dispatch(showMeasurements());
          dispatch(setHelpLinesLabelsVisible(true));
        }
      }}
      ssrIcon={Icon}
      enabled={active}
    />
  );
};

export default MeasureAction;
